import { CYBER_ASSESSMENT as cyberAssessment } from './cyber';
import { SINGLE_CATEGORY as singleCategory } from './singleCategory';

export const ASSESSMENTS = { cyberAssessment, singleCategory };
